// polyfills for browser
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
// =====================
import 'styles.js';

import React from 'react';
import {render} from 'react-dom';
import {Provider} from 'react-redux';
import {ConnectedRouter} from 'react-router-redux';

import store from './store/index';
import analytics from './features/analytics/index';
import history from './features/history/index';
import App from './App';

analytics.trackHistory();

const rootEl = document.getElementById('root');
render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <App />
    </ConnectedRouter>
  </Provider>,
  rootEl
);
